import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Params, Router, RouterModule } from '@angular/router';
import { EMediaBreakpoint } from 'projects/shared/lib/enum/media/media-breakpoint.enum';
import { INavigationEnvironment } from 'projects/shared/lib/interfaces/environment/navigation/navigation-environment.interface';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { Subscription } from 'rxjs';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { IProductCategoryService, IProductCategoryServiceToken } from 'projects/shared/lib/services/data/product-category/product-category-service.interface';
import { TreeViewItem } from '../../tree-view/item/tree-view-item.model';
import { IAuthService, IAuthServiceToken } from 'projects/shared/lib/services/infrastructure/authentication/auth-service.interface';
import { INavigationService, INavigationServiceToken } from 'projects/shared/lib/services/infrastructure/navigation/navigation-service.interface';
import { IConfigurationServiceToken } from 'projects/shared/lib/services/infrastructure/configuration/configuration-service.interface';
import { IMediaService, IMediaServiceToken } from 'shared/services/ui/media/media-service.interface';


@Component({
  selector: 'app-category-nav-bar',
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './category-nav-bar.component.html',
  styleUrls: ['./category-nav-bar.component.scss']
})
export class CategoryNavBarComponent implements OnInit, OnDestroy {
  protected readonly mediaService: IMediaService = inject(IMediaServiceToken);
  protected readonly authService: IAuthService;
  protected readonly productCategoryService: IProductCategoryService;
  protected readonly router: Router;
  protected readonly navigationService: INavigationService;

  public categoryTreeItemList: TreeViewItem[] | undefined;
  public activeCategory: string | undefined;
  protected activeComponentSubscription: Subscription | undefined;
  public activeComponent: string | undefined;
  public isCategoryNavBarVisible: boolean | undefined;
  private categoryTreeSubscription: Subscription | undefined;

  public brandPage: INavigationEnvironment;

  private mediaBreakpointSubscription: Subscription | undefined;

  public eMediaBreakpoint: typeof EMediaBreakpoint;
  public mediaBreakpoint: EMediaBreakpoint;
  private authenticationSubscription: Subscription | undefined;
  public isAuthenticated: boolean | undefined;

  public constructor() {
    this.authService = inject(IAuthServiceToken);
    this.productCategoryService = inject(IProductCategoryServiceToken);
    this.router = inject(Router);
    this.navigationService = inject(INavigationServiceToken);

    this.brandPage = ENVIRONMENT.brandPage;
    ServiceLocator.injector.get(IConfigurationServiceToken).brandPageGet().subscribe((brandPage) => {
      if (this.brandPage != undefined) {
        this.brandPage.routerlink = brandPage.routerlink as string;
        let queryParams = new URLSearchParams(brandPage.queryParams);
        let queryParamsObject: Params = {};
        queryParams.forEach((value, key) => {
          queryParamsObject[key] = value;
        });
        this.brandPage.queryParams = queryParamsObject;
      }
    });
    this.eMediaBreakpoint = EMediaBreakpoint;
    this.mediaBreakpoint = this.mediaService.mediaBreakpointGet();
  }

  public ngOnInit(): void {
    this.productCategoryService.productCategoryTreeInitAsync();

    this.authenticationSubscriptionInit();
    this.activeComponentSubscriptionInit();
    this.categoryTreeSubscriptionInit();
    this.mediaBreakpointSubscriptionInit();
  }

  public ngOnDestroy(): void {
    this.authenticationSubscription?.unsubscribe();
    this.activeComponentSubscription?.unsubscribe();
    this.categoryTreeSubscription?.unsubscribe();
    this.mediaBreakpointSubscription?.unsubscribe();
  }

  private authenticationSubscriptionInit() {
    if (!this.authenticationSubscription) {
      this.authenticationSubscription = this.authService.authenticatedGet().subscribe(
        (isAuthenticated) => this.isAuthenticated = isAuthenticated
      );
    }
  }

  private categoryTreeSubscriptionInit() {
    if (!this.categoryTreeSubscription) {

      this.categoryTreeSubscription = this.productCategoryService.categoryTreeChangedGet().subscribe(
        (categoryTreeItemList) => {
          let resultList: TreeViewItem[] = [];

          categoryTreeItemList?.forEach(
            i => {
              if (i.isRootCategory == false) {
                resultList.push(i);
              } else {
                resultList.push(...i.children);
              }
            }
          );

          this.categoryTreeItemList = resultList;
        }
      );

    }
  }

  protected activeComponentSubscriptionInit() {
    if (!this.activeComponentSubscription) {
      this.activeComponentSubscription = this.navigationService.activeComponentSubject.subscribe(
        (urlString) => {
          this.activeComponent = urlString;
          this.isCategoryNavBarVisible = urlString != undefined && (ENVIRONMENT.categoryNavbarVisibleRoutes?.find(route => urlString.indexOf(route) >= 0) != undefined);
          let queryParamKey = 'categoryKey';
          let startIndex = urlString?.indexOf(queryParamKey);
          if (startIndex != undefined && startIndex >= 0) {
            let queryParamOffset = queryParamKey.length + 1;
            let queryParamValueLength = 7;
            startIndex = startIndex + queryParamOffset;
            this.activeCategory = urlString?.substring(startIndex, startIndex + queryParamValueLength);
            return;
          }

          startIndex = urlString?.indexOf('promo');
          if (startIndex != undefined && startIndex >= 0) {
            this.activeCategory = urlString;
            return;
          }

          this.activeCategory = undefined;
        }
      );
    }
  }

  private mediaBreakpointSubscriptionInit() {
    if (this.mediaBreakpointSubscription == undefined) {
      this.mediaBreakpointSubscription = this.mediaService.mediaBreakpointChangeGet().subscribe(
        (mediaBreakpoint: EMediaBreakpoint) => {
          setTimeout(() => {
            this.mediaBreakpoint = mediaBreakpoint;
          });
        }
      );
    }
  }

}
